const initPagination = () => {
    const postArchive = document.querySelector('[data-post-archive]'),
        salonsArchive = postArchive?.querySelector('.SalonArchiveGrid')

    if (!postArchive) return

    Alpine.store('postArchiveStack', [])

    Livewire.on('load-more-posts', () => postArchive.querySelectorAll('a[wire\\:key]')
        .forEach(el => Alpine.store('postArchiveStack').push(el.outerHTML.replace('wire:', 'data-'))))

    Livewire.on('change-archive-page', () => {
        Alpine.store('postArchiveStack', []);
        (salonsArchive ?? postArchive)?.scrollIntoView();
    })

    Livewire.on('change-archive-map', () => {
        Alpine.store('postArchiveStack', []);
        document.querySelector('[data-map="salons"]')?.parentElement.scrollIntoView();
    })

    Livewire.on('change-archive-url', (details: { url: string }) => history.replaceState({}, '', details.url))
}

export default initPagination